module.exports = __webpack_public_path__ + "img/4medical.032bb786.png";